import { Component, OnInit, ViewChild, ElementRef, TemplateRef } from '@angular/core';
import { FormGroup, FormBuilder, FormControl, Validators, FormArray } from '@angular/forms';
import { practicebmtransactionadd, BMProjectActions, BMProjectActionsHistory, filecontent, practiceBMGranttChart } from '../../../../models/slakpi';
import { division, user, department } from '../../../../models/admin';
import { UtilityService } from '../../../../services/utility.service';
import { BMApiService } from '../../../../services/bm.service';
import { UserService } from '../../../../services/user.service';
import { SpinnerVisibilityService } from 'ng-http-loader';
import Swal from 'sweetalert2'
import { Router, ActivatedRoute, Params } from '@angular/router';
declare var google: any;

import {
  AngularGridInstance,
  Column,
  FieldType,
  Filters,
  Formatter,
  GridOption,
  FileType,
  Formatters,
  OnEventArgs,
  MenuCallbackArgs,

} from 'angular-slickgrid';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { uniqBy } from 'lodash';
import { ToasterService } from '../../../../toaster.service';
import { Options } from '@angular-slider/ngx-slider';
import { formatDate } from '@angular/common';
@Component({
  selector: 'app-practice-bm-progress-transaction',
  templateUrl: './practice-bm-progress-transaction.component.html',
  styleUrls: ['./practice-bm-progress-transaction.component.css']
})
export class PracticeBMProgressTransactionComponent implements OnInit {
  @ViewChild('progressStatusUpdateTemplate', { static: false }) progressStatusUpdateTemplate: TemplateRef<any>;
  @ViewChild('attachmentTemplate', { static: false }) attachmentTemplate: TemplateRef<any>;
  public targetBandbtnElement: HTMLElement;
  public position_band: object = { X: 600, Y: 340 };
  //public shouldShowchart1 = false;
  //public shouldShowchart2 = false;
  showMyContainerarea: boolean = true;
  showMyContainerbar: boolean = true;
  gridOptions: GridOption;
  cmtsGrid: AngularGridInstance;
  datasetComments: any;
  issueGrid: AngularGridInstance;
  angularGrid: AngularGridInstance;
  datasetIssues: any;
  columnIssueDefinitions: Column[];
  historycolumnDefinitions: Column[];
  public filterSettings: Object;
  public toolbar: string[];
  public pageSettings: Object;
  options: Options = {
    showTicksValues: true,
    floor: 0,
    ceil: 10,
    step: 1

  };
  enableUpdate: boolean = true;
  projectActionsHistoryDataSetFull: any[];
  itemuno: any;
  public objProjectActionHistory: BMProjectActionsHistory = new BMProjectActionsHistory();
  public objProjects: practicebmtransactionadd = new practicebmtransactionadd();
  progressTypeValue: any;
  projectID: any;
  data: any;
  dataset: any[];

 
  bmProgressMasterData: any[];
  loading: boolean;
  columnDefinitions: Column[];
  public uploadedFiles: Array<File> = [];
  statusDDList = [{ value: 1, text: 'Draft' }, { value: 2, text: 'Initiated' }, { value: 3, text: 'Execution' }, { value: 4, text: 'Hold' }, { value: 5, text: 'Completed' }]
  bmProgressItemUno: any;
  modalRef: BsModalRef;
  modalRefAtt: BsModalRef;
  projectActionHistoryID: Object;
  projectActionsHistoryData: any;
  projectActionsHistoryDataSet: any[];
  attachementList: any[];
  actionType: any;
  columnDefinitionsType: Column[];
    projectActionsHistoryDataSetFull_DD: any;
    bmProgressUno: any;
    percentageInt: number;
    isUpdateProgress: { showTicksValues: true; floor: number; ceil: number; step: number; };
    isUpdateProgressShow: boolean;
    projectActionsHistoryValueDataSet: any[];
    bmprogressName: any;
    planActualPecetageTotal: any;
    collectActualPecetageTotal: any;
    analyseActualPecetageTotal: any;
  adaptActualPecetageTotal: any;
  login_UserID: string='';
    userList: any;
    percentageActualValue: number;
    practiceBMGranttChartList: any;
    planAccordColor: string;
    collectAccordColor: string;
    analyseAccordColor: string;
    adaptAccordColor: string;
    planTargetPecetageTotal: number;
    collectTargetPecetageTotal: any;
    analyseTargetPecetageTotal: any;
  adaptTargetPecetageTotal: any;
  isChartTypeCurve = false;
  isChartTypeProgress = true;
    palnCurveChartData: any=[];
  collectCurveChartData: any = [];
  analyseCurveChartData: any = [];
  adaptCurveChartData: any = [];
  curveChartData: any = [];
    percentageActual: number;
    filterDataSet: any=[];
    plannedStartDate: string;
    plannedEndDate: string;
    progressColor: string;
    colorBaseText: string;
    actualPercentageTotal: any;
    isAdmin: boolean;
    user: any;
  tenantUno: any;
  projectActionList: any = [];
  constructor(public restApi: BMApiService, private modalService: BsModalService, private toaster: ToasterService, private _activatedRoute: ActivatedRoute, public router: Router, public utilityService: UtilityService, private userService: UserService, private spinner: SpinnerVisibilityService, private formBuilder: FormBuilder) {
    this.user = this.userService.getUserInfo();
    this.login_UserID = this.user.id;
    this.tenantUno = this.user.tenantUno;
  }
  

  ngOnInit() {
    this.userService.CheckLogin();
    this.isAdmin = (this.user.role == 'Administrator' || this.user.role == 'BM Administrator') ? true : false;
    //this.modalRef.hide();
    //this.modalRefAtt.hide();
    this.loading = true;
    this.gridOptions = {
      autoHeight: true,
      enableAutoResize: true,
      enablePagination: true,
      pagination: {
        pageSizes: [5, 10, 20, 50, 100, 500],
        pageSize: 5
      },
      enableFiltering: true,
      alwaysShowVerticalScroll: false,
      enableRowSelection: true,
      autoResize: {
        containerId: 'musherat-grid',
        delay: 1,
        sidePadding: 10,
        bottomPadding: 10
      },
      enableExcelExport: true,
      enableExcelCopyBuffer: true,
      enableFilterTrimWhiteSpace: true,
      showCustomFooter: true, // display some metrics in the bottom custom footer
      enableContextMenu: true,
      enableCellMenu: true,
      forceFitColumns: true,

    };
    this._activatedRoute
      .queryParams
      .subscribe(params => {
        let itemUno = params['itemUno'];
        if (itemUno != '' && itemUno != null && itemUno != undefined) {
          this.itemuno = itemUno;
          this.getBMProgressProjects(this.itemuno);
          this.getPracticeBMGranttChart(this.itemuno);
          this.loadBMProjectActionsHistory();
          this.loadPerformanceMaster(5);
        }
        else {
          this.itemuno = '';
        }

      });
    this.userList = this.userService.getUserInfo();
    this.login_UserID = this.userList.id;

    



  }
  isChartCureveEnable() {
    
    this.isChartTypeCurve = true;
    this.isChartTypeProgress = false;
    
    if (this.palnCurveChartData.length > 0) {
      const mockDataset = [];
      for (let i = 0; i < this.palnCurveChartData.length; i++) {

        mockDataset[i] = {
          id: this.palnCurveChartData[i].id,
          //enteredDate:'12-03',
          enteredDate: this.palnCurveChartData[i].enteredDate.substring(0,10),
          target: this.planTargetPecetageTotal,
          actual: parseInt(this.palnCurveChartData[i].progress),
          percentageActual: this.palnCurveChartData[i].percentageActual
        }
      }
      this.curveChartData = mockDataset;
      setTimeout(() => {
        google.charts.setOnLoadCallback(this.practicebmprogresstransactionchart1);
      }, 300);
    }
    else {
      this.curveChartData = [];
    }
    
  }
  isChartProgressEnable() {
    this.isChartTypeCurve = false;
    this.isChartTypeProgress = true;
  
  }
  angularGridReady(angularGrid: AngularGridInstance) {
    this.angularGrid = angularGrid;
    this.userService.angularGrid = angularGrid;
  }

  getPracticeBMGranttChart(id: any) {

    let inpValue = new practiceBMGranttChart();
    inpValue.projectUno = id;
    inpValue.userUno = this.login_UserID;

    this.restApi.getPracticeBMGranttChart(inpValue)
      .subscribe(data => {
        if (data != null && data != undefined) {
          
          this.practiceBMGranttChartList = data;

          google.charts.load('current', { 'packages': ['gantt'] });
          google.charts.setOnLoadCallback(this.practicebmganttchart);

        }
        else {
          this.practiceBMGranttChartList = [];
        }
      },
        (error) => {
          //Called when error
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
      });
  }
  getBMProgressProjects(id: any) {

    let inpValue = new practicebmtransactionadd();
    inpValue.userUno = this.login_UserID;
    inpValue.languageUno = 1033;
    inpValue.itemUno = id;
    inpValue.condition = 2;
    inpValue.tenantUno = this.tenantUno;
    this.restApi.getProjects(inpValue)
      .subscribe(data => {
        
       
        //  this.objPM = data;
        this.objProjects.projectName = data[0].projectName;
        this.objProjects.comments = data[0].comments;
        this.objProjects.peer = data[0].peer;
        this.objProjects.division = data[0].division;
        this.objProjects.projectManager = data[0].projectManager;
        this.objProjects.projectManagerUno = data[0].projectManagerUno;
        this.objProjects.plannedStartDate = data[0].plannedStartDate;
        this.objProjects.plannedEndDate = data[0].plannedEndDate;
        this.plannedStartDate = formatDate(data[0].plannedStartDate, 'dd-MM-yyy', 'en-US');
        this.plannedEndDate = formatDate(data[0].plannedEndDate, 'dd-MM-yyy', 'en-US');
      },
        (error) => {
          //Called when error
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
      });
  }


  dateReplace(date: any) {
    if (date != '' && date != null && date != undefined) {
      return date.replace(/(\d+[-])(\d+[-])/, '$2$1');
    }
    else {
return ''
    }
  }
  loadPerformanceMaster(value: any) {
    this.progressTypeValue = value;
    let valuePer: any = [];
    this.spinner.show();
    let inpValue = new BMProjectActions();
    inpValue.languageUno = 1033;
    inpValue.itemUno = (this.projectID != '' && this.projectID != null && this.projectID != undefined) ? this.projectID : this.itemuno;
    inpValue.condition = 3;
    inpValue.userUno = this.login_UserID;
    inpValue.tenantUno = this.tenantUno;
    this.restApi.getProjectActions(inpValue)
      .subscribe(data => {
        
        let dayDiff: any;
        
       this.filterDataSet = uniqBy(data, 'id');
        this.data = this.filterDataSet.filter(a => a.bmProgressItemUno == value);
        this.projectActionList = this.filterDataSet;
        //Over allprogress color
        let filterList1 = this.filterDataSet.filter(item =>
          (
            (item.progressStatus == 'Completed' && new Date(this.dateReplace(item.updatedOn)) <= new Date(this.dateReplace(item.endDate))) ||
            (
              (item.progressStatus != 'Completed' && item.progressStatus != 'Draft' &&
                !(new Date(this.dateReplace(item.endDate)) < new Date() && this.calculateDate(new Date(), new Date(this.dateReplace(item.endDate))) > 15)) ||
              (item.progressStatus != 'Completed' && item.progressStatus != 'Draft' &&
                !(new Date() > new Date(this.dateReplace(item.endDate)) && this.calculateDate(new Date(), new Date(this.dateReplace(item.endDate))) <= 15))
            )

          )
        );
        let filterList2 = this.filterDataSet.filter(item => item.progressStatus != 'Completed' && new Date() > new Date(this.dateReplace(item.endDate)) && this.calculateDate(new Date(), new Date(this.dateReplace(item.endDate))) > 15);

        let filterList3 = this.filterDataSet.filter(item => item.progressStatus != 'Completed' && new Date() > new Date(this.dateReplace(item.endDate)) && this.calculateDate(new Date(), new Date(this.dateReplace(item.endDate))) <= 15);
        // let filterPlanList3 = planColorList.filter(item => item.progressStatus != 'Completed');

        if (filterList2 != null && filterList2 != undefined && filterList2.length > 0) {
          this.progressColor = "progress-bar bg-g-pbm-red";
          this.colorBaseText = "Critical variance";
        }
        else if (filterList3 != null && filterList3 != undefined && filterList3.length > 0) {
          this.progressColor = "progress-bar bg-g-pbm-yellow";
          this.colorBaseText = "Small varaiance";
        }
        else if (filterList1 != null && filterList1 != undefined && filterList1.length > 0) {
          this.progressColor = "progress-bar bg-g-pbm-green";
          this.colorBaseText = "On track";
        }

        else {
          this.progressColor = "progress-bar bg-g-pbm-gray";
          this.colorBaseText = "Has not started yet";
        }



        this.enableUpdate = this.filterDataSet.filter(a => a.bmProgressItemUno < value && a.progressStatus != 'Completed').length > 0 ? false : true;
        const mockDataset = [];
        //Accoerdian Color Changes
        let planColorList = this.filterDataSet.filter(a => a.bmProgressItemUno == 5 );
        let collectColorList = this.filterDataSet.filter(a => a.bmProgressItemUno == 6);
        let analyseColorList = this.filterDataSet.filter(a => a.bmProgressItemUno == 7 );
        let adaptColorList = this.filterDataSet.filter(a => a.bmProgressItemUno == 8);
       
        //Plan Accord color start
        let currentDate = new Date();
        //Get record progress status not equal to completed
        //let filterPlanList1 = planColorList.filter(item => item.progressStatus != 'Completed');
        let filterPlanList1 = planColorList.filter(item =>
          (
            (item.progressStatus == 'Completed' && new Date(this.dateReplace(item.updatedOn)) <= new Date(this.dateReplace(item.endDate)) ) ||
            (
              (item.progressStatus != 'Completed' && item.progressStatus != 'Draft' &&
                !(new Date(this.dateReplace(item.endDate)) < new Date() && this.calculateDate(new Date(), new Date(this.dateReplace(item.endDate))) > 15)) ||
              (item.progressStatus != 'Completed' && item.progressStatus != 'Draft' &&
                !(new Date() > new Date(this.dateReplace(item.endDate)) && this.calculateDate(new Date(), new Date(this.dateReplace(item.endDate))) <= 15))
              )

          )
        );
        let filterPlanList2 = planColorList.filter(item => item.progressStatus != 'Completed' && new Date() > new Date(this.dateReplace(item.endDate)) && this.calculateDate(new Date(), new Date(this.dateReplace(item.endDate))) > 15);

        let filterPlanList3 = planColorList.filter(item => item.progressStatus != 'Completed'&&new Date() > new Date(this.dateReplace(item.endDate)) && this.calculateDate(new Date(), new Date(this.dateReplace(item.endDate))) <= 15);
        // let filterPlanList3 = planColorList.filter(item => item.progressStatus != 'Completed');

        if (filterPlanList1 != null && filterPlanList1 != undefined && filterPlanList1.length>0) {
          this.planAccordColor = "card-header collapsed bg-pbm-green";
        }
        else if (filterPlanList2 != null && filterPlanList2 != undefined && filterPlanList2.length > 0) {
          this.planAccordColor = "card-header collapsed bg-pbm-red";
        }
        else if (filterPlanList3 != null && filterPlanList3 != undefined && filterPlanList3.length > 0) {
          this.planAccordColor = "card-header collapsed bg-pbm-yellow";
        }
        else {
          this.planAccordColor = "card-header collapsed bg-pbm-gray";
        }
        //Plan Accord Color End

        //Collect Accord color start
        //Get record progress status not equal to completed

        let filterCollectList1 = collectColorList.filter(item =>
          (
            (item.progressStatus == 'Completed' && new Date(this.dateReplace(item.updatedOn)) <= new Date(this.dateReplace(item.endDate)) ) ||
            (
              (item.progressStatus != 'Completed' && item.progressStatus != 'Draft' && !(new Date(this.dateReplace(item.endDate)) < new Date() && this.calculateDate(new Date(), new Date(this.dateReplace(item.endDate))) > 15)) ||
              (item.progressStatus != 'Completed' && item.progressStatus != 'Draft' && !(new Date() > new Date(this.dateReplace(item.endDate)) && this.calculateDate(new Date(), new Date(this.dateReplace(item.endDate))) <= 15)))

          )
        );
        let filterCollectList2 = collectColorList.filter(item => new Date() > new Date(this.dateReplace(item.endDate)) && this.calculateDate(new Date(), new Date(this.dateReplace(item.endDate))) > 15);
        let filterCollectList3 = collectColorList.filter(item => new Date() > new Date(this.dateReplace(item.endDate)) && this.calculateDate(new Date(), new Date(this.dateReplace(item.endDate))) <= 15);
        // let filterPlanList3 = planColorList.filter(item => item.progressStatus != 'Completed');

        if (filterCollectList1 != null && filterCollectList1 != undefined && filterCollectList1.length > 0) {
          this.collectAccordColor = "card-header collapsed bg-pbm-green";
        }
        else if (filterCollectList2 != null && filterCollectList2 != undefined&& filterCollectList2.length > 0) {
          this.collectAccordColor = "card-header collapsed bg-pbm-red";
        }
        else if (filterCollectList3 != null && filterCollectList3 != undefined && filterCollectList3.length > 0) {
          this.collectAccordColor = "card-header collapsed bg-pbm-yellow";
        }
        else {
          this.collectAccordColor = "card-header collapsed bg-pbm-gray";
        }
        //Collect Accord Color End


        //Adapt Accord color start
        //Get record progress status not equal to completed
        let filterAdaptList1 = adaptColorList.filter(item =>
          (
            (item.progressStatus == 'Completed' && new Date(this.dateReplace(item.updatedOn)) <= new Date(this.dateReplace(item.endDate)) ) ||
            (
              (item.progressStatus != 'Completed' && item.progressStatus != 'Draft' && !(new Date(this.dateReplace(item.endDate)) < new Date() && this.calculateDate(new Date(), new Date(this.dateReplace(item.endDate))) > 15)) ||
              (item.progressStatus != 'Completed' && item.progressStatus != 'Draft' && !(new Date() > new Date(this.dateReplace(item.endDate)) && this.calculateDate(new Date(), new Date(this.dateReplace(item.endDate))) <= 15)))

          )
        );
        let filterAdaptList2 = adaptColorList.filter(item => new Date() > new Date(this.dateReplace(item.endDate)) && this.calculateDate(new Date(), new Date(this.dateReplace(item.endDate))) > 15);
        let filterAdaptList3 = adaptColorList.filter(item => new Date() > new Date(this.dateReplace(item.endDate)) && this.calculateDate(new Date(), new Date(this.dateReplace(item.endDate))) <= 15);
        // let filterPlanList3 = planColorList.filter(item => item.progressStatus != 'Completed');

        if (filterAdaptList1 !=null && filterAdaptList1 != undefined && filterAdaptList1.length > 0) {
          this.adaptAccordColor = "card-header collapsed bg-pbm-green";
        }
        else if (filterAdaptList2!=null && filterAdaptList2 != undefined && filterAdaptList2.length > 0) {
          this.adaptAccordColor = "card-header collapsed bg-pbm-red";
        }
        else if (filterAdaptList3 != null && filterAdaptList3 != undefined && filterAdaptList3.length > 0) {
          this.adaptAccordColor = "card-header collapsed bg-pbm-yellow";
        }
        else {
          this.adaptAccordColor = "card-header collapsed bg-pbm-gray";
        }
        //Analyse Accord Color End


        //Analyse Accord color start
        //Get record progress status not equal to completed
        let filterAnalyseList1 = analyseColorList.filter(item =>
          (
            (item.progressStatus == 'Completed' && new Date(this.dateReplace(item.updatedOn)) <= new Date(this.dateReplace(item.endDate)) ) ||
            (
              (item.progressStatus != 'Completed' && item.progressStatus != 'Draft' && !(new Date(this.dateReplace(item.endDate)) < new Date() && this.calculateDate(new Date(), new Date(this.dateReplace(item.endDate))) > 15)) ||
              (item.progressStatus != 'Completed' && item.progressStatus != 'Draft' && !(new Date() > new Date(this.dateReplace(item.endDate)) && this.calculateDate(new Date(), new Date(this.dateReplace(item.endDate))) <= 15)))

          )
        );
        let filterAnalyseList2 = analyseColorList.filter(item => new Date() > new Date(this.dateReplace(item.endDate)) && this.calculateDate(new Date(), new Date(this.dateReplace(item.endDate))) > 15);
        let filterAnalyseList3 = analyseColorList.filter(item => new Date() > new Date(this.dateReplace(item.endDate)) && this.calculateDate(new Date(), new Date(this.dateReplace(item.endDate))) <= 15);
        // let filterPlanList3 = planColorList.filter(item => item.progressStatus != 'Completed');

        if (filterAnalyseList1 != undefined && filterAnalyseList1 != null && filterAnalyseList1.length>0) {
          this.analyseAccordColor = "card-header collapsed bg-pbm-green";
        }
        else if (filterAnalyseList2 != null && filterAnalyseList2 != undefined&& filterAnalyseList2.length > 0) {
          this.analyseAccordColor = "card-header collapsed bg-pbm-red";
        }
        else if (filterAnalyseList3 != null && filterAnalyseList3 != undefined && filterAnalyseList3.length > 0) {
          this.analyseAccordColor = "card-header collapsed bg-pbm-yellow";
        }
        else {
          this.analyseAccordColor = "card-header collapsed bg-pbm-gray";
        }
        //Analyse Accord Color End

        for (let i = 0; i < this.data.length; i++) {
         
          mockDataset[i] = {
            id: this.data[i].id,
            bmProgressName: this.data[i].bmProgressName,
            bmProgressItemUno: this.data[i].bmProgressItemUno,
            bmProgressUno: this.data[i].bmProgressUno,
            percentage: this.data[i].percentage + '%',
            assignedUser: this.data[i].assignedUser,
            progressStatus: this.data[i].progressStatus,
            pertageInt: this.data[i].percentage,
            percentageActual: this.checkNullOrEmpty(this.data[i].percentageActual) + '%',
            percentageActualInt: this.data[i].percentageActual ,
            updatedOn:this.data[i].updatedOn,
            enteredBy: this.data[i].enteredBy,
            startDate: this.data[i].startDate,
            endDate:this.data[i].endDate, 
           
           
          };
         
          valuePer.push(this.data[i].percentageActual);
        }



        //document.getElementById("planprogress").style.width = this.percentageTotal + "%";
        this.dataset = mockDataset;
        if (mockDataset.length > 0) {
          this.setGridBMProgressDefn();
        }
        else {
          this.setGridBMProgressDefn();
        }
        setTimeout(() => {
          this.progressPercetageTarget();
        }, 300);
        setTimeout(() => {
          this.progressPercentageActual();
        }, 500);
       
        this.bmProgressMasterData = mockDataset;
        this.loading = false;
        this.spinner.hide()
      },
        (error) => {
          //Called when error
          this.spinner.hide();
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
        this.spinner.hide();
      });
  }


  progressPercetageTarget() {
    //Target Percetnage Calculate
    //plan target
    let planTargetPecetnageList = this.filterDataSet.filter(a => a.bmProgressItemUno == 5 && a.percentageTarget != '');
    let planTarget: any = [];
    for (let i = 0; i < planTargetPecetnageList.length; i++) {
      planTarget.push(parseInt(planTargetPecetnageList[i].percentageTarget));
    }
    if (planTarget.length > 0) {
      this.planTargetPecetageTotal = planTarget.reduce((a, b) => a + b, 0);
    }
    else {
      this.planTargetPecetageTotal = 0;
    }
    //collect target
    let collectTargetPecetnageList = this.filterDataSet.filter(a => a.bmProgressItemUno == 6 && a.percentageTarget != '');
    let collectTarget: any = [];
    for (let i = 0; i < collectTargetPecetnageList.length; i++) {
      collectTarget.push(parseInt(collectTargetPecetnageList[i].percentageTarget));
    }
    if (collectTarget.length > 0) {
      this.collectTargetPecetageTotal = collectTarget.reduce((a, b) => a + b, 0);
    }
    else {
      this.collectTargetPecetageTotal = 0;
    }
    //analyze target
    let analyseTargetPecetnageList = this.filterDataSet.filter(a => a.bmProgressItemUno == 7 && a.percentageTarget != '');
    let analyseTarget: any = [];
    for (let i = 0; i < analyseTargetPecetnageList.length; i++) {
      analyseTarget.push(parseInt(analyseTargetPecetnageList[i].percentageTarget));
    }
    if (analyseTarget.length > 0) {
      this.analyseTargetPecetageTotal = analyseTarget.reduce((a, b) => a + b, 0);
    }
    else {
      this.analyseTargetPecetageTotal = 0;
    }
    //adapt target
    let adaptTargetPecetnageList = this.filterDataSet.filter(a => a.bmProgressItemUno == 8 && a.percentageTarget != '');
    let adaptTarget: any = [];
    for (let i = 0; i < adaptTargetPecetnageList.length; i++) {
      adaptTarget.push(parseInt(adaptTargetPecetnageList[i].percentageTarget));
    }
    if (adaptTarget.length > 0) {
      this.adaptTargetPecetageTotal = adaptTarget.reduce((a, b) => a + b, 0);
    }
    else {
      this.adaptTargetPecetageTotal = 0;
    }
  }



  progressPercentageActual() {
    //Actual Percentage Calculate
    let planpercentageCovert: any;
    let collectpercentageCovert: any;
    let analysepercentageCovert: any;
    let adaptpercentageCovert: any;
    //plan actual
    let planActual: any = [];
   
    let planActualPecetnageList = this.filterDataSet.filter(a => a.bmProgressItemUno == 5 && a.percentageActual != '');
    for (let i = 0; i < planActualPecetnageList.length; i++) {
      planActual.push(parseInt(planActualPecetnageList[i].percentageActual));
    }

    if (planActual.length > 0) {
      planpercentageCovert = planActual.reduce((a, b) => a + b, 0);
      this.planActualPecetageTotal = Math.round((planpercentageCovert / this.planTargetPecetageTotal) * 100);

    }
    else {
      this.planActualPecetageTotal = 0;
    }
    //collect actual
    let collectActual: any = [];
    let collectActualPecetnageList = this.filterDataSet.filter(a => a.bmProgressItemUno == 6 && a.percentageActual != '');
    for (let i = 0; i < collectActualPecetnageList.length; i++) {
      collectActual.push(parseInt(collectActualPecetnageList[i].percentageActual));
    }

    if (collectActual.length > 0) {
      collectpercentageCovert= collectActual.reduce((a, b) => a + b, 0);
      this.collectActualPecetageTotal = Math.round((collectpercentageCovert / this.collectTargetPecetageTotal) * 100);
      Math.round

    }
    else {
      this.collectActualPecetageTotal = 0;
    }

    //analyse actual
    let analyseActual: any = [];

    let analyseActualPecetnageList = this.filterDataSet.filter(a => a.bmProgressItemUno == 7 && a.percentageActual != '');
    for (let i = 0; i < analyseActualPecetnageList.length; i++) {
      analyseActual.push(parseInt(analyseActualPecetnageList[i].percentageActual));
    }

    if (analyseActual.length > 0) {
      analysepercentageCovert= analyseActual.reduce((a, b) => a + b, 0);
      this.analyseActualPecetageTotal = Math.round((analysepercentageCovert / this.analyseTargetPecetageTotal) * 100);

    }
    else {
      this.analyseActualPecetageTotal = 0;
    }

    //adapt actual
    let adaptActual: any = [];
    let adaptActualPecetnageList = this.filterDataSet.filter(a => a.bmProgressItemUno == 8 && a.percentageActual != '');
    for (let i = 0; i < adaptActualPecetnageList.length; i++) {
      adaptActual.push(parseInt(adaptActualPecetnageList[i].percentageActual));
    }

    if (adaptActual.length > 0) {
      adaptpercentageCovert = adaptActual.reduce((a, b) => a + b, 0);
      this.adaptActualPecetageTotal = Math.round((adaptpercentageCovert / this.adaptTargetPecetageTotal) * 100);

    }
    else {
      this.adaptActualPecetageTotal = 0;
    }


    this.actualPercentageTotal = ((planpercentageCovert) ? planpercentageCovert : 0) + ((collectpercentageCovert) ? collectpercentageCovert : 0) + ((analysepercentageCovert) ? analysepercentageCovert : 0) + ((adaptpercentageCovert) ? adaptpercentageCovert:0);
  }


  calculateDate(date1, date2) {
    //our custom function with two parameters, each for a selected date

   let  diffc = date1.getTime() - date2.getTime();
    //getTime() function used to convert a date into milliseconds. This is needed in order to perform calculations.

   let  days = Math.round(Math.abs(diffc / (1000 * 60 * 60 * 24)));
    //this is the actual equation that calculates the number of days.

    return days;
  }
  setGridBMProgressDefn() {
    let temp = this;
    this.columnDefinitionsType = [

      {
        id: 'bmProgressName', name: 'Task Name', field: 'bmProgressName', sortable: true, type: FieldType.string, filterable: false, width:200,

      },
      {
        id: 'enteredBy', name: 'Action By', field: 'enteredBy', sortable: true, type: FieldType.string, filterable: false, width: 40,

      },
      {
        id: 'bmProgressValue', name: 'Target', field: 'percentage', sortable: true, type: FieldType.string, filterable: false, width: 10,

      }, 
      {
        id: 'percentageActual', name: 'Actual', field: 'percentageActual', sortable: true, type: FieldType.string, filterable: false, width: 10,

      },
      {
        id: 'progressStatus', name: 'Status', field: 'progressStatus', sortable: true, type: FieldType.string, filterable: false, width: 10,

      },
      {
        id: 'endDate', name: 'End Date ', field: 'endDate', sortable: true, type: FieldType.string, filterable: false, width: 40,

      },
      {
        id: 'updatedOn', name: 'Last Updated', field: 'updatedOn', sortable: true, type: FieldType.string, filterable: false, width: 40,

      },

      {
        id: 'action', name: 'Action', field: 'action', cssClass: 'blue', width: 10,
        excludeFromExport: true,
        formatter: this.actionFormatter,
        cellMenu: {
          hideCloseButton: false,
          commandTitleKey: 'COMMANDS',
          commandItems: [
            {
              command: 'delete-row', titleKey: 'EDIT_ROW', positionOrder: 62, title: 'Update Status',
              iconCssClass: 'fa fa-user', cssClass: 'blue', textCssClass: 'bold',
              itemVisibilityOverride: (args: MenuCallbackArgs) => {
                let data = args.dataContext;

                if (this.isAdmin)
                  return true;
                else if (!this.isAdmin && this.login_UserID == data.assignedUser)
                  return true;
                else
                  return false;
              },
              action: (e, args) => {
                
                //if (args.dataContext.progressStatus == 'Completed') {
                //  this.toaster.show('error', 'Error', 'Unable to change the completed action');
                //  return
                //}
                if (!this.enableUpdate) {
                  this.toaster.show('error', 'Error', 'Please complete the previous pending task');
                  return
                }
                this.objProjectActionHistory = new BMProjectActionsHistory();
                let rdata: any = args.dataContext;
                this.bmProgressItemUno = rdata.id;
                this.bmprogressName = rdata.bmProgressName;
                this.bmProgressUno = rdata.bmProgressUno;

                this.percentageInt = parseInt(rdata.pertageInt);
                this.percentageActual = parseInt(rdata.percentageActual);
                this.objProjectActionHistory.progress = this.percentageActual;
                this.percentageActualValue = this.percentageActual;
                if (this.percentageInt > this.percentageActual) {
                  this.isUpdateProgressShow = true;
                }
                else {
                  this.isUpdateProgressShow = false;
                }

                //this.loadBMProjectActionsHistoryvalue();

                let datalist = this.projectActionsHistoryDataSet.filter(a => a.actionText.replace(' Progress changed to complete', '') == this.bmprogressName);



                const mockDataset = [];
                for (let i = 0; i < datalist.length; i++) {

                  mockDataset[i] = {
                    id: datalist[i].id,
                    actionTrnUno: datalist[i].actionTrnUno,
                    projectUno: datalist[i].projectUno,
                    fileName: datalist[i].fileName,
                    fileContent: datalist[i].fileContent,
                    contentType: datalist[i].contentType,
                    comments: datalist[i].comments,
                    actionType: datalist[i].actionType,
                    actionText: datalist[i].actionText,
                    actionStatus: datalist[i].actionStatus,
                    enteredDate: datalist[i].enteredDate,
                    progress: datalist[i].progress,
                    progressPrecentage: datalist[i].progress + '%',
                    remarks: datalist[i].remarks,
                    filePath: datalist[i].filePath
                  };
                }



                //document.getElementById("planprogress").style.width = this.percentageTotal + "%";
                this.projectActionsHistoryValueDataSet = mockDataset;

                if (mockDataset.length > 0) {
                  this.setGridBMProjectActionsHistoryValueDefn();
                }
                else {
                  this.setGridBMProjectActionsHistoryValueDefn();
                  this.projectActionsHistoryValueDataSet = [];
                }
              
                this.options = {
                  showTicksValues: true,
                  floor: 0,
                  ceil: this.percentageInt,
                  step: 1
                }
                this.actionTypeValueAndText(rdata);
                let userList: any;
                this.uploadedFiles = [];
                //let arrayList: any = [];
                //for (let i = 0; i < userList.length; i++) {
                //  let assignusers = userList[i].assignedUser;
                //  arrayList.push(assignusers);
                //}
                //this.assignUserList = arrayList;

                //For Email

               // this.loadBMProjectActionsHistoryvalue();
                this.modalRef = this.modalService.show(
                  this.progressStatusUpdateTemplate,
                  Object.assign({}, {
                    class: 'gray modal-lg',
                    backdrop: true,
                    keyboard: true,
                    focus: true,
                    show: false,
                    ignoreBackdropClick: true,
                    animated: true
                  })
                );
              },
              // only show command to 'Delete Row' when the task is not completed

            },
            //  { divider: true, command: '', positionOrder: 63 },
            //  {
            //    command: 'delete-row', titleKey: 'DELETE_ROW', positionOrder: 64, title: 'Delete',
            //    iconCssClass: 'fa fa-trash', cssClass: 'red', textCssClass: 'bold',
            //    action: (e, args) => {
            //      Swal.fire({
            //        title: 'Delete',
            //        text: 'Please confirm to delete the record',
            //        type: 'warning',
            //        showCancelButton: true,
            //        confirmButtonText: 'Ok',
            //        cancelButtonText: 'Cancel'
            //      }).then((result) => {
            //        if (result.value) {

            //        } else if (result.dismiss === Swal.DismissReason.cancel) {

            //        }
            //      })
            //    },
            //    // only show command to 'Delete Row' when the task is not completed

            //  },


          ],
        }
      }

    ]


  }
  actionFormatter: Formatter = (row, cell, value, columnDef, dataContext) => {
    return `<div class="fake-hyperlink"> <i class="fa fa-ellipsis-h fa-lg"></i></div>`;
  };
  checkNullOrEmpty(value: any) {
    if (value == null || value == '' || value == undefined) {
      return '0';
    }
    else {
      return value
    }
  }
  onSubmit(val1) {
    
    if (!val1) {
      //Swal.fire('Error', 'Please enter the required information.', 'error');
      //this.toaster.show('error', 'Error', 'Please enter all the required information');
      return
    }

    else {
      if (this.uploadedFiles && this.uploadedFiles.length > 0) {
        //Check file count 
        if (this.uploadedFiles.length > 1) {
          this.toaster.show('error', 'Error', 'You can upload one file only');
          return false;
        }

        for (var i = 0; i < this.uploadedFiles.length; i++) {
          let fileName = this.uploadedFiles[i].name.toLowerCase();
          let fileSize = this.uploadedFiles[i].size;
          //Check file size
          if (!this.userService.checkFileSize(fileSize)) {
            this.toaster.show('error', 'Error', 'A file size should not above 30MB.');
            return false;
          }
          //To check file exe
          if (!this.userService.checkFileValuranabity(fileName, fileSize)) {
            this.toaster.show('error', 'Error', 'Please select the correct format file');
            return false;
          }
        }
      }
      this.EditBMProjectActionsHistory();
    }
  }

  EditBMProjectActionsHistory() {
    
    
    if (this.objProjectActionHistory.progress >= this.percentageActualValue) {
      

      let obj = new BMProjectActionsHistory();
      let diffActual = this.objProjectActionHistory.progress - this.percentageActual;
      obj.id = 0;
      obj.actionStatus = (this.objProjectActionHistory.actionStatus) ? this.objProjectActionHistory.actionStatus.toString() : '';
      obj.comments = (this.objProjectActionHistory.comments) ? this.objProjectActionHistory.comments.toString() : '';
      obj.nextUpdate = (this.objProjectActionHistory.nextUpdate) ? this.objProjectActionHistory.nextUpdate.toString() : '';
      obj.actionType = this.objProjectActionHistory.actionType;
      obj.actionText = this.objProjectActionHistory.actionText;
      obj.projectUno = this.itemuno;
      obj.actionTrnUno = this.bmProgressItemUno;
      obj.userUno = this.login_UserID;
      obj.tenantUno = this.tenantUno;
      obj.remarks = this.objProjectActionHistory.remarks;
      obj.progress = this.objProjectActionHistory.progress;
      obj.percentageActual = (diffActual) ? diffActual:0;
      obj.bmProgressUno = this.bmProgressUno;
      if (this.objProjectActionHistory.progress == 0) {
        obj.actionStatus = 'Draft';
      }
      else if (this.objProjectActionHistory.progress == this.percentageInt) {
        obj.actionStatus = 'Completed';
      }
      else {
        obj.actionStatus = 'Initiated';
      }
      
      //For Email
      obj.projectName = this.objProjects.projectName;
      obj.projectManager = this.objProjects.projectManager;
      obj.projectManagerUno = this.objProjects.projectManagerUno;

      obj.taskName = this.bmprogressName;
      obj.target = this.percentageInt + "%";
      obj.actual = this.percentageActual + "%";
      obj.status = obj.actionStatus;

      //BM Project Task is ready for next level (bmProgressItemUno : 5-Plan, 6-Collect, 7-Analyse 8-Adapt)
      if (obj.actionStatus == "Completed" && this.objProjectActionHistory.actionType == "Plan") {    //
        //To get Next level assign useruno
        let filteredList: any = this.projectActionList.filter(a => a.bmProgressItemUno == 6);
        obj.projectNextLevelUserUno = filteredList[0].assignedUser
      }
      else if (obj.actionStatus == "Completed" && this.objProjectActionHistory.actionType == "Collect") {
        //To get Next level assign useruno
        let filteredList: any = this.projectActionList.filter(a => a.bmProgressItemUno == 7);
        obj.projectNextLevelUserUno = filteredList[0].assignedUser
      }
      else if (obj.actionStatus == "Completed" && this.objProjectActionHistory.actionType == "Analyse") {
        //To get Next level assign useruno
        let filteredList: any = this.projectActionList.filter(a => a.bmProgressItemUno == 8);
        obj.projectNextLevelUserUno = filteredList[0].assignedUser
      }
      else if (obj.actionStatus == "Completed" && this.objProjectActionHistory.actionType == "Adapt") {
      }

      this.restApi.addEditBMProjectActionHistory(obj)
        .subscribe(data => {

          if (data != null && data != undefined && data != '') {
            this.projectActionHistoryID = data;
            this.saveFile();
            //Swal.fire({
            //  type: 'success',
            //  title: 'Practice Bench Mark Progress Transaction',
            //  showConfirmButton: false,
            //  timer: 1500
            //})
            
              this.toaster.show('success', 'Success', 'Item saved.');

            this.modalRef.hide();
            this.loadPerformanceMaster(this.progressTypeValue);
            this.loadBMProjectActionsHistory();
            setTimeout(() => { this.spinner.hide();; }, 900);
          }
          else {
            //Swal.fire('Error', 'Something went wrong', 'error');
            this.toaster.show('error', 'Error', 'Something went wrong');
            this.spinner.hide();

          }
        },
          (error) => {
            //Called when error
            this.spinner.hide();
          }
        ).add(() => {
          //Called when operation is complete (both success and error)
          //this.spinner.hide();
        });
      return true;
      //}
    } else {
      this.toaster.show('error', 'Error', 'The selected precentage is not valid');
      return
    }
  }


  actionTypeValueAndText(data: any) {
    if (this.progressTypeValue == 5) {
      this.objProjectActionHistory.actionType = "Plan";
      this.objProjectActionHistory.actionText = data.bmProgressName + " Progress changed to complete";
    }
    else if (this.progressTypeValue == 6) {
      this.objProjectActionHistory.actionType = "Collect";
      this.objProjectActionHistory.actionText = data.bmProgressName + " Progress changed to complete";
    }
    else if (this.progressTypeValue == 7) {
      this.objProjectActionHistory.actionType = "Analyze";
      this.objProjectActionHistory.actionText = data.bmProgressName + " Progress changed to complete";
    }
    else if (this.progressTypeValue == 8) {
      this.objProjectActionHistory.actionType = "Adapt";
      this.objProjectActionHistory.actionText = data.bmProgressName + " Progress changed to complete";
    }
  }

  saveFile() {
    if (this.uploadedFiles && this.uploadedFiles.length > 0) {
      if (this.uploadedFiles.length > 5) {
        this.toaster.show('error', 'Error', 'Maximum 5 Files to be upload');
        return false;
      }
      let formData = new FormData();
      let isFileReadyForUpload = false;
      for (var i = 0; i < this.uploadedFiles.length; i++) {
        let allowFile = false;
        let fileName = this.uploadedFiles[i].name.toLowerCase();
        let fileSize = this.uploadedFiles[i].size;
        //Check file size
        let allowFileSize = false;
        allowFileSize = this.userService.checkFileSize(fileSize);
        if (!allowFileSize) {
          this.toaster.show('error', 'Error', 'A file size should not above 30MB.');
          return;
        }
        //To check filee size exe  
        allowFile = this.userService.checkFileValuranabity(fileName, fileSize);

        if (allowFile) {
          formData.append("file", this.uploadedFiles[i]);
          isFileReadyForUpload = true;
        }
      }
      if (isFileReadyForUpload) {
        formData.append("id", this.projectActionHistoryID.toString());
        formData.append("flag", "ProjectTransaction");
        formData.append("userUno", this.login_UserID.toString());
        this.restApi.fileManagerFileUpload(formData)
          .subscribe(data => {
            
            if (data == null && data == undefined && data == '') {

            }
            else {
              //  this.toaster.show('success', 'Success', 'File uploaded.');
              //this.RefreshDirectory();
              //this.selectedRecord = new fileManager();
            }
            this.uploadedFiles = [];
            this.spinner.hide();
          },
            (error) => {
              this.spinner.hide();
            }
          ).add(() => {
            this.spinner.hide();
          });
      }
    }
    //else {
    //  this.toaster.show('error', 'Error', 'Please select the file');
    //}
  }
  uploadFiles(id: any) {
    this.spinner.show();
    
    if (this.uploadedFiles.length > 5) {
      this.toaster.show('error', 'Error', 'Maximum 5 Files to be upload');
      return false;
    }
    for (var i = 0; i < this.uploadedFiles.length; i++) {
      let allowFile = false;
      let fileName = this.uploadedFiles[i].name.toLowerCase();
      let fileSize = this.uploadedFiles[i].size;
      //Check file size
      let allowFileSize = false;
      allowFileSize = this.userService.checkFileSize(fileSize);
      if (!allowFileSize) {
        this.toaster.show('error', 'Error', 'A file size should not above 30MB.');
        return;
      }
      //To check filee size exe  
      allowFile = this.userService.checkFileValuranabity(fileName, fileSize);

      if (allowFile) {
        this.restApi.progressBMProjectActionFileUpload(this.uploadedFiles[i], this.uploadedFiles[i].name, id).subscribe(data => {

          this.spinner.hide();
        },
          (error) => {
            //Called when error
            Swal.fire('Error', 'Something went wrong', 'error')
            this.spinner.hide();
          }
        ).add(() => {
          //Called when operation is complete (both success and error)
          this.spinner.hide();
        });
      }
    }
  }

  loadCurveData() {
    //Curve Chart 
    if (this.palnCurveChartData.length > 0) {
      const mockDataset = [];
      for (let i = 0; i < this.palnCurveChartData.length; i++) {

        mockDataset[i] = {
          id: this.palnCurveChartData[i].id,
          //enteredDate:'12-03',
          enteredDate: this.palnCurveChartData[i].enteredDate,
          target: this.planTargetPecetageTotal,
          actual: parseInt(this.palnCurveChartData[i].progress),
          percentageActual: this.palnCurveChartData[i].percentageActual
        }
      }
      this.curveChartData = mockDataset;
      setTimeout(() => {
        google.charts.setOnLoadCallback(this.practicebmprogresstransactionchart1);
      }, 300);
    }
    else {
      this.curveChartData = [];
    }
  }

  loadBMProjectActionsHistory() {
    this.actionType = '';
    let valuePer: any = [];
    this.spinner.show();
    let inpValue = new BMProjectActionsHistory();
    inpValue.languageUno = 1033;
    inpValue.itemUno = this.itemuno;
    inpValue.condition = 3;
    inpValue.userUno = this.login_UserID;

    this.restApi.getBMProjectActionHistory(inpValue)
      .subscribe(data => {
        

        this.projectActionsHistoryData = uniqBy(data, 'id');

        this.palnCurveChartData = this.projectActionsHistoryData.filter(a => a.actionType == 'Plan' && a.enteredDate != '' && a.progress != 0).sort((a, b) => a.enteredDate.localeCompare(b.enteredDate));
        this.collectCurveChartData = this.projectActionsHistoryData.filter(a => a.actionType == 'Collect' && a.enteredDate != '' && a.progress != 0).sort((a, b) => a.enteredDate.localeCompare(b.enteredDate));;
        this.analyseCurveChartData = this.projectActionsHistoryData.filter(a => a.actionType == 'Analyse' && a.enteredDate != '' && a.progress != 0).sort((a, b) => a.enteredDate.localeCompare(b.enteredDate));;
        this.adaptCurveChartData = this.projectActionsHistoryData.filter(a => a.actionType == 'Adapt' && a.enteredDate != '' && a.progress != 0).sort((a, b) => a.enteredDate.localeCompare(b.enteredDate));;
        
      

        const mockDataset = [];
        for (let i = 0; i < this.projectActionsHistoryData.length; i++) {

          mockDataset[i] = {
            id: this.projectActionsHistoryData[i].id,
            actionTrnUno: this.projectActionsHistoryData[i].actionTrnUno,
            projectUno: this.projectActionsHistoryData[i].projectUno,
            fileName: this.projectActionsHistoryData[i].fileName,
            fileContent: this.projectActionsHistoryData[i].fileContent,
            contentType: this.projectActionsHistoryData[i].contentType,
            comments: this.projectActionsHistoryData[i].comments,
            actionType: this.projectActionsHistoryData[i].actionType,
            actionText: this.projectActionsHistoryData[i].actionText,
            actionStatus: this.projectActionsHistoryData[i].actionStatus,
            enteredDate: this.projectActionsHistoryData[i].enteredDate,
            progress: this.projectActionsHistoryData[i].progress,
            progressPrecentage: this.projectActionsHistoryData[i].progress + '%',
            remarks: this.projectActionsHistoryData[i].remarks,
            filePath: this.projectActionsHistoryData[i].filePath,
            enteredBy: this.projectActionsHistoryData[i].enteredBy
          };
        }

        //document.getElementById("planprogress").style.width = this.percentageTotal + "%";
        this.projectActionsHistoryDataSet = mockDataset;
        this.projectActionsHistoryDataSetFull = mockDataset;
        this.projectActionsHistoryDataSetFull_DD = uniqBy(data, 'actionType');
        if (mockDataset.length > 0) {
          this.setGridBMProjectActionsHistoryDefn();
        }
        else {
          this.setGridBMProjectActionsHistoryDefn();
          this.projectActionsHistoryDataSet = [];
        }
        setTimeout(() => {
          this.loadCurveData();
        }, 900);
       
        this.loading = false;
        this.spinner.hide()
      },
        (error) => {
          //Called when error
          this.spinner.hide();
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
        this.spinner.hide();
      });
  }

  loadBMProjectActionsHistoryvalue() {
    
    this.actionType = '';
    let valuePer: any = [];
    this.spinner.show();
    let inpValue = new BMProjectActionsHistory();
    inpValue.languageUno = 1033;
    inpValue.itemUno = this.itemuno;
    inpValue.condition = 3;
    inpValue.userUno = this.login_UserID;

    this.restApi.getBMProjectActionHistory(inpValue)
      .subscribe(data => {
        
        this.loading = false;
        this.spinner.hide()
      },
        (error) => {
          //Called when error
          this.spinner.hide();
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
        this.spinner.hide();
      });
  }

  changeActionType(e) {
    this.actionType = (e.length == 0 || e[0].value == 'All') ? '' : e[0].value;
    if (this.actionType && this.actionType != '')
      this.projectActionsHistoryDataSet = this.projectActionsHistoryDataSetFull.filter(e => e.actionType == this.actionType)
    else
      this.projectActionsHistoryDataSet = this.projectActionsHistoryDataSetFull;

  }

  setGridBMProjectActionsHistoryValueDefn() {
    let temp = this;
    this.columnDefinitions = [

      {
        id: 'actionType', name: 'Type', field: 'actionType', sortable: true, type: FieldType.string, filterable: false, width: 10,

      },
      {
        id: 'actionText', name: 'Action', field: 'actionText', sortable: true, type: FieldType.string, filterable: false, width: 80,

      },
      {
        id: 'actionStatus', name: 'Status', field: 'actionStatus', sortable: true, type: FieldType.string, filterable: false, width: 20,

      },
      {
        id: 'progressPrecentage', name: 'Progress', field: 'progressPrecentage', sortable: true, type: FieldType.string, filterable: false, width: 10,

      },


      {
        id: 'comments', name: 'Comments', field: 'comments', sortable: true, type: FieldType.string, filterable: false, width: 50,

      },
      {
        id: 'remarks', name: 'Risk', field: 'remarks', sortable: true, type: FieldType.string, filterable: false, width: 50,

      },
      {
        id: 'enteredDate', name: 'Updated On', field: 'enteredDate', sortable: true, type: FieldType.string, filterable: false, width: 30,

      },
      {
        id: 'fileName', name: 'Files', field: 'fileName', sortable: true, type: FieldType.string, filterable: false, formatter: this.actualFormatter, width: 20,
        onCellClick: (e: Event, args: OnEventArgs) => {
          
          let data = args.dataContext;
          if (data.fileName != '') {
           
              this.attachementList = this.projectActionsHistoryDataSet.filter(a => a.id == data.id);

            this.modalRefAtt = this.modalService.show(
              this.attachmentTemplate,
              Object.assign({}, {
                class: 'gray modal-lg',
                backdrop: true,
                keyboard: true,
                focus: true,
                show: false,
                ignoreBackdropClick: true,
                animated: true
              })
            );
            return '1';
          }
          else if (data.fileName != '') {
            this.attachementList = [];
            return '0';
          }

        }
      },
    ]


  }

  setGridBMProjectActionsHistoryDefn() {
    let temp = this;
    this.historycolumnDefinitions = [

      {
        id: 'actionType', name: 'Type', field: 'actionType', sortable: true, type: FieldType.string, filterable: false, width:10,

      },
      {
        id: 'actionText', name: 'Action', field: 'actionText', sortable: true, type: FieldType.string, filterable: false, width: 80,

      },
      {
        id: 'actionStatus', name: 'Status', field: 'actionStatus', sortable: true, type: FieldType.string, filterable: false, width: 20,

      },
      {
        id: 'progressPrecentage', name: 'Progress', field: 'progressPrecentage', sortable: true, type: FieldType.string, filterable: false, width: 10,

      },


      {
        id: 'comments', name: 'Comments', field: 'comments', sortable: true, type: FieldType.string, filterable: false ,width: 50,

      },
      {
        id: 'remarks', name: 'Risk', field: 'remarks', sortable: true, type: FieldType.string, filterable: false, width: 50,

      },
      {
        id: 'enteredDate', name: 'Updated On', field: 'enteredDate', sortable: true, type: FieldType.string, filterable: false, width: 30,

      },
      {
        id: 'fileName', name: 'Files', field: 'fileName', sortable: true, type: FieldType.string, filterable: false, formatter: this.actualFormatter, width: 20,
        onCellClick: (e: Event, args: OnEventArgs) => {
          
          let data = args.dataContext;
          if (data.fileName != '') {
            if (data.fileName != "") {
              this.attachementList = this.projectActionsHistoryDataSet.filter(a => a.id == data.id);
            }
            else {
              this.attachementList = [];
            }

            this.modalRefAtt = this.modalService.show(
              this.attachmentTemplate,
              Object.assign({}, {
                class: 'gray modal-lg',
                backdrop: true,
                keyboard: true,
                focus: true,
                show: false,
                ignoreBackdropClick: true,
                animated: true
              })
            );
            return '1';
          }
          else if (data.fileName != '') {
            return '0';
          }
          
        }
      },
    ]


  }



  actualFormatter: Formatter = (row, cell, value, columnDef, data) => {


    if ((data.fileName != '')) {
      return '<a matTooltipClass="my-custom-tooltip-avg" title="File Download" (click)="AttachemtModelOpen(data)" class="bcopy-btn" style="cursor:pointer !important;"><i class="fa fa-file-o"></i></a>'
    }
    else {
      return ''
    }


  };
  AttachemtModelOpen(data:any) {
    let rdata: any = data;
                if (rdata.fileName != "") {
                  this.attachementList = this.projectActionsHistoryDataSet.filter(a => a.id == rdata.id);
                }
                else {
                  this.attachementList = [];
                }

                this.modalRef = this.modalService.show(
                  this.attachmentTemplate,
                  Object.assign({}, {
                    class: 'gray modal-lg',
                    backdrop: true,
                    keyboard: true,
                    focus: true,
                    show: false,
                    ignoreBackdropClick: true,
                    animated: true
                  })
                );
  }

    getFileIconClass(fileTitle: string) {

    if (fileTitle == '' || fileTitle == null)
      return "fa fa-file";

    var rtnClass = "fa fa-file";
    var strTitle = (fileTitle.indexOf('.') > 0) ? fileTitle.split('.')[1].toLowerCase() : 'unknown';

    switch (strTitle) {
      case 'txt':
        rtnClass = "fa fa-file-o";
        break;
      case 'doc':
        rtnClass = "fa fa-file-word-o";
        break;
      case 'docx':
        rtnClass = "fa fa-file-word-o";
        break;
      case 'xls':
        rtnClass = "fa fa-file-excel-o";
        break;
      case 'xlsx':
        rtnClass = "fa fa-file-excel-o";
        break;
      case 'pdf':
        rtnClass = "fa fa-file-pdf-o";
        break;
      case 'gif':
      case 'jpeg':
      case 'jpg':
      case 'png':
        rtnClass = "fa fa-file-picture-o";
        break;
      case 'mp3':
        rtnClass = "fa fa-file-audio-o";
        break;
      case 'mp4':
      case 'mpeg':
      case 'mpg':
      case 'avi':
        rtnClass = "fa fa-file-video-o";
        break;
      default:
        rtnClass = "fa fa-file";
        break;
    }

    return rtnClass;

  }

  AttachmentDownload(id: any, name: string) {
    let inpValue = new BMProjectActionsHistory();
    inpValue.languageUno = 1033;
    inpValue.itemUno = id;
    inpValue.condition = 2;
    inpValue.userUno = this.login_UserID;
    this.spinner.show();
    this.restApi.DownloadBMProjectActionHistoryFile(inpValue).subscribe(
      data => {
        
        this.spinner.hide();
        if (data != null) {
          
          if (window.navigator.msSaveOrOpenBlob) //IE & Edge
          {
            //msSaveBlob only available for IE & Edge
            window.navigator.msSaveBlob(data, name);
          }
          else //Chrome & FF
          {
            var url = window.URL.createObjectURL(data);
            var a = document.createElement('a');
            document.body.appendChild(a);
            a.setAttribute('style', 'display: none');
            a.href = url;
            a.download = name;
            a.click();
            window.URL.revokeObjectURL(url);
            a.remove(); // remove the element
          }

        }
        else {
          this.spinner.hide();
          Swal.fire('Error', 'Something went wrong', 'error');
        }
      },
      error => {
        Swal.fire('Error', 'Something went wrong', 'error')
        this.spinner.hide();
      },
      () => {
        // 'onCompleted' callback.
        this.spinner.hide();

      }
    );

  }
  backtoInbox() {

  }

 
  practicebmprogresstransactionchart1 = () => {
    
    if (this.curveChartData.length > 0) {
      let tempArray = [['Date', 'Target', 'Actual']];
      var act = 0;
      for (var i = 0; i < this.curveChartData.length; i++) {
        act = act + parseInt(this.curveChartData[i].percentageActual);
        tempArray.push([this.curveChartData[i].enteredDate, this.curveChartData[i].target, act]);
      }
      // Create the data table.

      const data = google.visualization.arrayToDataTable(tempArray);

      // Set chart options

      const options = {

        curveType: 'function',
        pointsVisible: true,
        legend: { position: 'bottom' },
        vAxis: { format: '#\'%\'' }
      };

      const chart = new google.visualization.LineChart(document.getElementById('practicebmprogresstransactionchart1'));
      chart.draw(data, options);
    }
    else {
      this.curveChartData = [];
    }


}

  practicebmganttchart = () => {

    var data = new google.visualization.DataTable();
    data.addColumn('string', 'Task ID');
    data.addColumn('string', 'Task Name');
    data.addColumn('string', 'Resource');
    data.addColumn('date', 'Start Date');
    data.addColumn('date', 'End Date');
    data.addColumn('number', 'Duration');
    data.addColumn('number', 'Percent Complete');
    data.addColumn('string', 'Dependencies');
    let tempArray = [];
    for (var i = 0; i < this.practiceBMGranttChartList.length; i++) {
      
      /*let startDate = this.practiceBMGranttChartList[i].startDate.substring(0, 10);
      let splitStartDate = startDate.split('-');
      let sdate = new Date(splitStartDate[2], splitStartDate[1] - 1, splitStartDate[0]);
      let endDate = this.practiceBMGranttChartList[i].endDate.substring(0, 10);
      let splitEndDate = endDate.split('-');
      let edate = new Date(splitEndDate[2], splitEndDate[1] - 1, splitEndDate[0]);
      */
      var sdate = new Date(this.practiceBMGranttChartList[i].startDate);
      var edate = new Date(this.practiceBMGranttChartList[i].endDate);

      tempArray.push([this.practiceBMGranttChartList[i].taskName, this.practiceBMGranttChartList[i].taskName, this.practiceBMGranttChartList[i].progressType, sdate, edate, this.practiceBMGranttChartList[i].duration, this.practiceBMGranttChartList[i].percentComplete, null]);

    }



    /* 
     data.addRows([
       ['2014Spring', 'Spring 2014', 'spring',
         new Date(2014, 2, 22), new Date(2014, 5, 20), null, 100, null],
       ['2014Summer', 'Summer 2014', 'summer',
         new Date(2014, 5, 21), new Date(2014, 8, 20), null, 100, null],
       ['2014Autumn', 'Autumn 2014', 'autumn',
         new Date(2014, 8, 21), new Date(2014, 11, 20), null, 100, null],
       ['2014Winter', 'Winter 2014', 'winter',
         new Date(2014, 11, 21), new Date(2015, 2, 21), null, 100, null],
       ['2015Spring', 'Spring 2015', 'spring',
         new Date(2015, 2, 22), new Date(2015, 5, 20), null, 50, null],
       ['2015Summer', 'Summer 2015', 'summer',
         new Date(2015, 5, 21), new Date(2015, 8, 20), null, 0, null],
       ['2015Autumn', 'Autumn 2015', 'autumn',
         new Date(2015, 8, 21), new Date(2015, 11, 20), null, 0, null],
       ['2015Winter', 'Winter 2015', 'winter',
         new Date(2015, 11, 21), new Date(2016, 2, 21), null, 0, null],
       ['Football', 'Football Season', 'sports',
         new Date(2014, 8, 4), new Date(2015, 1, 1), null, 100, null],
       ['Baseball', 'Baseball Season', 'sports',
         new Date(2015, 2, 31), new Date(2015, 9, 20), null, 14, null],
       ['Basketball', 'Basketball Season', 'sports',
         new Date(2014, 9, 28), new Date(2015, 5, 20), null, 86, null],
       ['Hockey', 'Hockey Season', 'sports',
         new Date(2014, 9, 8), new Date(2015, 5, 21), null, 89, null]
     ]);
     */
    var options = {
      height: 500,
      gantt: {
        trackHeight: 30,
        criticalPathEnabled: false,
        innerGridHorizLine: {
          stroke: '#f5f7f7',
          strokeWidth: 2
        },
        innerGridTrack: { fill: '#F0F0F0' },
        innerGridDarkTrack: { fill: '#EOEOEO' },
        palette: [
          {
            "color": "#fcba03",
            "dark": "#fcba03",
            "light": "#f7cf57"
          },
          {
            "color": "#07db0a",
            "dark": "#026b04",
            "light": "#299e2b"
          },
          {
            "color": "#04d4bb",
            "dark": "#036e61",
            "light": "#42cfbd"
          },
          {
            "color": "#2b7ebd",
            "dark": "#093c63",
            "light": "#0098d4"
          },
          {
            "color": "#85979e",
            "dark": "#5a666b",
            "light": "#88989e"
          }
        ]
      },
      labelStyle: {
        fontName: 'DubaiW23-Regular',
        fontSize: 11,
        color: '#757575',
        textalign: 'left',

        float: 'left'
      },
      
       
      percentEnabled: true,
      shadowEnabled: true,
      shadowColor: 'white',
      shadowOffset: 2,
      'hAxis': { 'textStyle': { 'fontSize': 11 } }
    };
    setTimeout(() => {
      data.addRows(tempArray);
      var chart = new google.visualization.Gantt(document.getElementById('chart_div_grantt'));

      chart.draw(data, options);


    }, 900);

  }

  onRadioButtonChange(type: any) {
    if (type == 'Plan') {
      if (this.palnCurveChartData.length > 0) {
        const mockDataset = [];
        for (let i = 0; i < this.palnCurveChartData.length; i++) {

          mockDataset[i] = {
            id: this.palnCurveChartData[i].id,
            //enteredDate:'12-03',
            enteredDate: this.palnCurveChartData[i].enteredDate,
            target: this.planTargetPecetageTotal,
            actual: parseInt(this.palnCurveChartData[i].progress),
            percentageActual: this.palnCurveChartData[i].percentageActual
          }
        }
        this.curveChartData = mockDataset;
        setTimeout(() => {
          google.charts.setOnLoadCallback(this.practicebmprogresstransactionchart1);
        }, 300);
      }
      else {
        this.curveChartData = [];
      }
    }
    else if (type == 'Collect') {
      if (this.collectCurveChartData.length > 0) {
        const mockDataset = [];
        for (let i = 0; i < this.collectCurveChartData.length; i++) {

          mockDataset[i] = {
            id: this.collectCurveChartData[i].id,
            //enteredDate:'12-03',
            enteredDate: this.collectCurveChartData[i].enteredDate,
            target: this.collectTargetPecetageTotal,
            actual: parseInt(this.collectCurveChartData[i].progress),
            percentageActual: this.collectCurveChartData[i].percentageActual
          }
        }

        this.curveChartData = mockDataset;
        setTimeout(() => {
          google.charts.setOnLoadCallback(this.practicebmprogresstransactionchart1);
        }, 300);
      }
      else {
        this.curveChartData = [];
      }
    }
    else if (type == 'Analyse') {
      if (this.analyseCurveChartData.length > 0) {
        const mockDataset = [];
        for (let i = 0; i < this.analyseCurveChartData.length; i++) {

          mockDataset[i] = {
            id: this.analyseCurveChartData[i].id,
            //enteredDate:'12-03',
            enteredDate: this.analyseCurveChartData[i].enteredDate,
            target: this.analyseTargetPecetageTotal,
            actual: parseInt(this.analyseCurveChartData[i].progress),
            percentageActual: this.analyseCurveChartData[i].percentageActual
          }
        }

        this.curveChartData = mockDataset;
        setTimeout(() => {
          google.charts.setOnLoadCallback(this.practicebmprogresstransactionchart1);
        }, 300);
    }
    else {
      this.curveChartData = [];
    }
    }
    else if (type == 'Adapt') {
      if (this.adaptCurveChartData.length > 0) {
        const mockDataset = [];
        for (let i = 0; i < this.adaptCurveChartData.length; i++) {

          mockDataset[i] = {
            id: this.adaptCurveChartData[i].id,
            //enteredDate:'12-03',
            enteredDate: this.adaptCurveChartData[i].enteredDate,
            target: this.adaptTargetPecetageTotal,
            actual: parseInt(this.adaptCurveChartData[i].progress),
            percentageActual: this.adaptCurveChartData[i].percentageActual
          }
        }

        this.curveChartData = mockDataset;
        setTimeout(() => {
          google.charts.setOnLoadCallback(this.practicebmprogresstransactionchart1);
        }, 300);
      }
      else {
        this.curveChartData = [];
      }
    }

  }

  cancel() {
    this.modalRef.hide();
  }
}

